module.exports = __webpack_public_path__ + "static/media/golfer-5-b.e8f2b1a2.png";